import React, { useRef } from 'react';
import { Order } from '../types';
import { Button } from './ui/Button';
import { Printer } from 'lucide-react';
interface TicketPrintProps {
  orderData: Partial<Order>;
  onPrintComplete: () => void;
}
export function TicketPrint({
  orderData,
  onPrintComplete
}: TicketPrintProps) {
  const ticketRef = useRef<HTMLDivElement>(null);
  const handlePrint = () => {
    const printWindow = window.open('', '', 'width=400,height=600');
    if (!printWindow) {
      alert('Veuillez autoriser les popups pour imprimer le ticket');
      onPrintComplete();
      return;
    }
    if (ticketRef.current) {
      const styles = 'body { font-family: monospace; padding: 20px; text-align: center; } ' + '.header { font-weight: bold; font-size: 18px; margin-bottom: 10px; } ' + '.logo { width: 80px; margin-bottom: 10px; } ' + '.row { display: flex; justify-content: space-between; margin: 5px 0; border-bottom: 1px dashed #ccc; } ' + '.footer { margin-top: 20px; font-size: 12px; } ' + '.big { font-size: 24px; font-weight: bold; margin: 10px 0; }';
      const htmlContent = '<html><head><title>Ticket VIP CLEAN</title><style>{`' + styles + '`}</style></head><body>' + ticketRef.current.innerHTML + '<script>window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); };</script></body></html>';
      printWindow.document.write(htmlContent);
      printWindow.document.close();
      setTimeout(() => {
        onPrintComplete();
      }, 1000);
    }
  };
  return <div className="space-y-4" data-id="element-178">
      <div className="bg-white border-2 border-gray-800 p-4 max-w-[300px] mx-auto text-center font-mono text-sm shadow-lg" ref={ticketRef} data-id="element-179">
        <img src="https://vipclean.tn/wp-content/uploads/2022/08/Nouveau-projetlogovipclean-150x150.png" alt="VIP Clean" className="w-20 mx-auto mb-2 grayscale" data-id="element-180" />
        <div className="font-bold text-lg border-b-2 border-black pb-2 mb-2" data-id="element-181">
          TICKET DE COLLECTE
        </div>

        <div className="text-left space-y-2" data-id="element-182">
          <div className="flex justify-between" data-id="element-183">
            <span data-id="element-184">CLIENT:</span>
            <span className="font-bold" data-id="element-185">{orderData.clientName}</span>
          </div>
          <div className="flex justify-between" data-id="element-186">
            <span data-id="element-187">TÉL:</span>
            <span data-id="element-188">{orderData.clientPhone}</span>
          </div>
          <div className="border-t border-dashed border-gray-400 my-2" data-id="element-189"></div>
          <div className="flex justify-between items-center" data-id="element-190">
            <span data-id="element-191">TYPE:</span>
            <span className="font-bold" data-id="element-192">{orderData.type}</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-193">
            <span data-id="element-194">QTÉ:</span>
            <span className="text-2xl font-bold" data-id="element-195">{orderData.quantity}</span>
          </div>
          <div className="border-t border-dashed border-gray-400 my-2" data-id="element-196"></div>
          <div className="text-center" data-id="element-197">
            <div className="text-xs text-gray-500" data-id="element-198">LIVRAISON ESTIMÉE</div>
            <div className="font-bold" data-id="element-199">{orderData.estimatedDeliveryDate}</div>
          </div>
        </div>

        <div className="mt-4 pt-2 border-t-2 border-black text-xs" data-id="element-200">
          VIP CLEAN - 71 000 000
          <br data-id="element-201" />
          Merci de votre confiance
        </div>
      </div>

      <Button onClick={handlePrint} fullWidth size="lg" leftIcon={<Printer className="w-5 h-5" data-id="element-203" />} className="bg-gray-900 hover:bg-gray-800" data-id="element-202">
        IMPRIMER LE TICKET (OBLIGATOIRE)
      </Button>

      <p className="text-xs text-center text-gray-500" data-id="element-204">
        L'impression est requise pour valider la commande.
      </p>
    </div>;
}